<template>
  <div class="table-settings-form">
    <table-columns-sidesheet ref="tableColumnsModal" :columns="columns" @apply="saveColumns"></table-columns-sidesheet>

    <loader
      v-if="loadingColumns"
      style="z-index: 1"
      label="Данные загружаются"
      :active="loadingColumns"
      height="300"
    ></loader>

    <div v-else>
      <section class="default-columns">
        <h2 class="h2">Столбцы по умолчанию</h2>
        <h-button @click="setDefaultColumns">
          Настроить столбцы по умолчанию
          <span class="columns-count">{{ defaultColumnsLength }}</span>
        </h-button>
      </section>
      <section class="conditions">
        <h2 class="h2">Условия</h2>

        <div class="conditions__note">
          С помощью условий можно настроить таблицу для ролей и должностей. Перетаскивайте условия, чтобы настроить
          приоритет их использования (чем выше условие, тем оно приоритетней).
        </div>

        <conditions
          ref="conditions"
          class="conditions__list"
          :conditions="savedConditions"
          :columns="columns"
        ></conditions>

        <c-button-2
          class="conditions__add"
          size="small"
          :icon="{ icon: 'plus', color: 'primary' }"
          type="with-icon"
          label="Добавить условие"
          @click="addCondition"
        />
      </section>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/loader";
import HButton from "@/components/button";
import Button2 from "@/components/controls2/Button";
import TableColumnsSidesheet from "@/components/modals/table-columns/sidesheet";
import Conditions from "../conditions";

import { Column } from "@/entities/structures/column";

export default {
  name: "table-settings-form",
  components: {
    Loader,
    TableColumnsSidesheet,
    HButton,
    Conditions,
    "c-button-2": Button2,
  },
  props: ["table", "settings"],

  data() {
    return {
      columns: [],

      savedDefaultColumns: [],
      savedConditions: [],

      defaultColumns: [],

      loadingColumns: false,
    };
  },

  computed: {
    categoriesColumns() {
      return this.columns.filter((c) => c.isCategory).map((c) => c.id);
    },
    defaultColumnsLength() {
      let categoriesCount = 0;

      this.defaultColumns.forEach((c) => {
        if (this.categoriesColumns.includes(c)) {
          categoriesCount += 1;
        }
      });

      return this.defaultColumns.length - categoriesCount;
    },
  },

  watch: {
    table() {
      this.getColumns();
    },
  },

  created() {
    this.getColumns();

    if (this.settings) {
      this.savedDefaultColumns = this.settings.columns.map((c) => c.code);
      this.defaultColumns = this.savedDefaultColumns;
      this.savedConditions = this.settings.conditions;
    }
  },

  methods: {
    getColumns() {
      this.loadingColumns = true;
      return this.$store
        .dispatch("tablesSettings/getTableColumns", {
          table: this.table,
        })
        .then((columns) => {
          this.columns = columns.map((c) => new Column(c));
          this.savedDefaultColumns = this.columns.filter((c) => !c.isCategory).map((c) => c.id);

          if (!this.settings) {
            this.defaultColumns = this.savedDefaultColumns;
          }
          this.loadingColumns = false;
        });
    },

    setDefaultColumns() {
      this.$refs.tableColumnsModal.open("default", {
        columns: this.defaultColumns.filter((c) => !this.categoriesColumns.includes(c)),
        title: "Столбцы по умолчанию",
      });
    },
    setConditionColumns({ id, columns }) {
      this.$refs.tableColumnsModal.open(id, columns);
    },

    saveColumns({ id, selected }) {
      if (id === "default") this.defaultColumns = selected;
    },
    addCondition() {
      this.$refs.conditions.addCondition();
    },

    reset() {
      this.$refs.conditions.update(this.savedConditions);
      this.defaultColumns = this.savedDefaultColumns;
    },

    getParams() {
      const params = {
        section: this.table,
        columns: this.defaultColumns,
        conditions: this.$refs.conditions.getConditions(),
      };

      return params;
    },
    update(model) {
      this.savedDefaultColumns = model.columns.map((c) => c.code);
      this.savedConditions = model.conditions;
      this.$refs.conditions.update(this.savedConditions);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.table-settings-form {
  .columns-count {
    font-weight: 400;
    color: $color-label;
  }
  .h2 {
    font-size: 18px;
    font-weight: 500;
  }
  .default-columns {
    margin-bottom: 40px;

    .h2 {
      margin-bottom: 20px;
    }
  }
  .conditions {
    &__note {
      font-size: 12px;
      color: $color-label;
      margin-bottom: 24px;
      line-height: 1.2;
    }
    &__add {
      margin-top: 20px;
    }
  }

  @include mobileAndTablet {
    .conditions {
      &__add {
        &:hover,
        &:active,
        &:focus {
          border-color: #d3d8df !important;
        }
      }
    }
  }

  @include onlyStandartMobile {
    .default-columns {
      margin-bottom: 30px;
    }
  }
}
</style>
